module.exports = __webpack_public_path__ + "img/foot-logo.487951f4.png";